<template>
  <div class="input-box">
    <!-- 表头的 slot -->
    <el-input class="input" v-model="headerItem[headerItem.prop]" style="width:100%"
      :placeholder="((headerItem.placeholder==null||headerItem.placeholder==undefined)? headerItem.label:headerItem.placeholder)"
      clearable @clear="
        handleSearch(headerIndex, {
          prop: headerItem.prop,
          value: headerItem[headerItem.prop],
          type: 'text',
        })
      ">
      <template #append>
        <span @click="
          handleSearch(headerIndex, {
            prop: headerItem.prop,
            value: headerItem[headerItem.prop],
            type: 'text',
          })
        ">
          <el-icon class="hand" style="vertical-align: middle">
            <Search />
          </el-icon>
        </span>
      </template>
    </el-input>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs, onMounted, watch} from "vue";
export default {
  props: {
    headerItem: Object,
    headerIndex: Number,
    key: Number,
    height: Number,
  },
  setup(props, { emit }) {
    const handleSearch = (index, option) => {
      console.log(option, "传入参数");
      emit("searchFnc", option);
    };

    onMounted(()=>{
      if(props.headerItem.type=="InputSearch"){
        props.headerItem[props.headerItem.prop] = ""
      }
    })

    return {
      handleSearch,
    };
  },
};
</script>

<style scoped>
.searchbar-btn {
  width: 32px;
  height: 35px;
  line-height: 33px;
  text-align: center;
  cursor: pointer;
  margin-right: -4px;
  position: absolute;
  right: -33px;
}

/* .el-input-group {
  width: 200px;
} */

.input /deep/.el-input-group__append {
  display: inline-block;
  vertical-align: middle;
  line-height: 40px;
}

.input /deep/.el-input__wrapper {
  margin-right: 4px;
  padding-right: 30px;
}
</style>
